import { render } from "./TeamLeader.vue?vue&type=template&id=34c76aa8"
import script from "./TeamLeader.vue?vue&type=script&lang=js"
export * from "./TeamLeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__